<template>
	<div class="container">
		<div class="card">
			<div class="header-row border-b border-gray-200">
				<span class="text-capitalize">{{ view }}</span>

				Applicant Tracking System (ATS)<span v-if="view === 'edit'">: (ID: {{ ats.id }} | Slug: {{ ats.slug }})</span>

				<a target="_blank" :href="`/view/integrations?id=${ats.id}`" class="float-right">View</a>
			</div>

			<div class="card-body lead-form">
				<section class="general-info">
					<div class="form-group form-group-half">
						<span v-html="label('name', 'Name')"></span>

						<input
              data-w-input="ats-name"
							type="text"
							class="form-control"
							:value="ats.name"
							@input="update('name', $event.target.value)"
							id="name"
							name="name"
              data-form-type="other"
						/>
					</div>

					<hr style="margin: 2rem 0"/>

					<div class="form-group form-group-half" v-if="view === 'edit'">
						<input
              data-w-input="ats-archived"
							type="checkbox"
							class="form-control"
							:checked="ats.archived"
							@change="update('archived', $event.target.checked)"
							id="archived"
							name="archived"
						/>

						<span v-html="label('archived', 'Archived?')"></span>
					</div>

					<div class="form-group form-group-half">
						<input
              data-w-input="ats-internal-only"
							type="checkbox"
							class="form-control"
							:checked="ats.internal_only"
							@change="update('internal_only', $event.target.checked)"
							id="internal_only"
							name="internal_only"
						/>

						<span v-html="label('internal_only', 'Internal Only?')"></span>
					</div>

					<div class="form-group form-group-half">
						<input
              data-w-input="ats-use-export-details"
							type="checkbox"
							class="form-control"
							:checked="ats.export_details_ats"
							@change="update('export_details_ats', $event.target.checked)"
							id="export_details_ats"
							name="export_details_ats"
						/>

						<span v-html="label('export_details_ats', 'Use Export Details?')"></span>
					</div>

					<!-- referral -->
					<div class="form-group form-group-half" v-if="view === 'edit'" v-show="ats.allow_lead_modifications">
						<input
              data-w-input="ats-use-referral"
							type="checkbox"
							class="form-control"
							:checked="ats.use_referral"
							@change="update('use_referral', $event.target.checked)"
							id="referral"
							name="use_referral"
						/>

						<span v-html="label('use_referral', 'Use Referral Settings?')"></span>
					</div>

					<div class="form-group form-group-half" v-if="view === 'edit'" v-show="ats.allow_lead_modifications">
						<input
              data-w-input="ats-use-campaign-location"
							type="checkbox"
							class="form-control"
							:checked="ats.use_campaign_location"
							@change="update('use_campaign_location', $event.target.checked)"
							id="use_campaign_location"
							name="use_campaign_location"
						/>

						<span v-html="label('use_campaign_location', 'Use Campaign Location?')"></span>
					</div>

					<div class="form-group form-group-half">
						<input
              data-w-input="ats-allow-lead-mod"
							type="checkbox"
							class="form-control"
							:checked="ats.allow_lead_modifications"
							@change="update('allow_lead_modifications', $event.target.checked)"
							id="allow_lead_modifications"
							name="allow_lead_modifications"
						/>

						<span v-html="label('allow_lead_modifications', 'Use Lead Modifications?')"></span>
					</div>

					<div class="form-group form-group-half">
						<input
              data-w-input="ats-should-exclude-on-fail"
							type="checkbox"
							id="exclude_on_fail"
							class="form-control"
							name="exclude_on_fail"
							:checked="typeof ats.exclude_on_fail !== 'undefined' ? ats.exclude_on_fail : true"
							@change="update('exclude_on_fail', $event.target.checked)"
						/>

						<span v-html="label('exclude_on_fail', 'Should exporter exclude on fail/prevent?')"></span>
					</div>

					<section v-show="ats.allow_lead_modifications && ats.use_referral" class="json-info">
						<hr style="margin: 2rem 0"/>

						<h5>
							<span v-html="label('referral_key', 'Referral CRM Key')"></span>
						</h5>

						<input
              data-w-input="ats-referral-key"
              type="text"
              v-model="ats.referral_key"
              data-form-type="other"
              class="form-control" placeholder="value"
            />
					</section>

					<hr style="margin: 2rem 0"/>

					<section v-show="ats.allow_lead_modifications && ats.use_campaign_location" class="json-info">
						<hr style="margin: 2rem 0"/>

						<h5>
							<span v-html="label('campaign_location_key', 'Campaign Location CRM Key')"></span>
						</h5>

						<input
              data-w-input="ats-campaign-location-key"
              data-form-type="other"
              type="text"
              v-model="ats.campaign_location_key"
              class="form-control" placeholder="value"
            />
					</section>

					<hr style="margin: 2rem 0"/>

					<!-- Rules Section -->
					<section class="json-info">
						<h5>
							<span v-html="label('rules', 'Rules')"></span>
						</h5>

						<nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
							<!-- Basic Tab -->
							<template v-slot:basic>
								<div class="line-slipt">
									<div class="form-group" style="margin-bottom: 0.25rem">
										<label>Key</label>
										<input
                      data-w-input="ats-basic-rules-key"
                      data-form-type="other"
                      type="text"
                      v-model="rules_key"
                      class="form-control"
                      placeholder="key"
                    />
									</div>

									<div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
										<label>Value</label>
										<input
                      data-w-input="ats-basic-rules-value"
                      data-form-type="other"
                      type="text"
                      v-model="rules_value"
                      class="form-control"
                      placeholder="value"
                    />
									</div>
									<div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
										<button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateRulesByKeyValue">Add/Update</button>
										<button class="btn btn-danger" @click="removeRulesByKeyValue">Remove</button>
									</div>
								</div>

								<small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>
								<small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

								<div class="relative flex flex-col border border-gray-200mt-3 mb-0">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<json-viewer :json="JSON.stringify(ats.rules)"/>
									</div>
								</div>
							</template>

							<!-- Builder Tab -->
							<template v-slot:builder>
								<JsonEditor :objData="ats.rules || {}" v-model="ats.rules" :data-w-input="`ats-builder-${ats.rules}`"></JsonEditor>
							</template>

							<!-- Raw Tab -->
							<template v-slot:raw>
								<div class="card">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<textarea
                      data-w-input="ats-raw-rules"
                      rows="6"
                      class="form-control"
                      @blur="ats.rules = $event.target.value"
                      :value="JSON.stringify(ats.rules)"
                    ></textarea>
									</div>
								</div>
							</template>
						</nav-tabs>
					</section>

					<hr style="margin: 2rem 0"/>

					<!-- Extra Rules Section -->
					<section class="json-info">
						<h5>
							<span v-html="label('extra_rules', 'Extra Rules')"></span>
						</h5>
						<nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
							<!-- Basic Tab -->
							<template v-slot:basic>
								<div class="line-slpit">
									<div class="form-group" style="margin-bottom: 0.25rem">
										<label>Key</label>
										<input
                      data-w-input="ats-basic-extra-rules-key"
                      data-form-type="other"
                      type="text"
                      v-model="extra_rules_key"
                      class="form-control"
                      placeholder="key"
                    />
									</div>

									<div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
										<label>Value</label>
										<input
                      data-w-input="ats-basic-extra-rules-value"
                      data-form-type="other"
                      type="text"
                      v-model="extra_rules_value"
                      class="form-control"
                      placeholder="value"
                    />
									</div>
									<div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
										<button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateExtraRulesByKeyValue">Add/Update</button>
										<button class="btn btn-danger" @click="removeExtraRulesByKeyValue">Remove</button>
									</div>
								</div>

								<small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>
								<small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

								<div class="relative flex flex-col border border-gray-200mt-3 mb-0">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<json-viewer :json="JSON.stringify(ats.extra_rules)"/>
									</div>
								</div>
							</template>

							<!-- Builder Tab -->
							<template v-slot:builder>
								<JsonEditor :objData="ats.extra_rules || {}" v-model="ats.extra_rules"></JsonEditor>
							</template>

							<!-- Raw Tab -->
							<template v-slot:raw>
								<div class="card">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<textarea
                      data-w-input="ats-raw-extra-rules"
                      rows="6"
                      class="form-control"
                      @blur="ats.extra_rules = $event.target.value"
                      :value="JSON.stringify(ats.extra_rules)"
                    ></textarea>
									</div>
								</div>
							</template>
						</nav-tabs>
					</section>
					<hr style="margin: 2rem 0"/>

					<!-- Field Keys Section -->
					<section class="json-info">
						<h5>
							<span v-html="label('field_keys', 'Field Keys')"></span>
						</h5>
						<nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
							<!-- Basic Tab -->
							<template v-slot:basic>
								<div class="line-slipt">
									<div class="form-group" style="margin-bottom: 0.25rem">
										<label>Key</label>
										<input
                      data-w-input="ats-basic-fieldkey-key"
                      data-form-type="other"
                      type="text"
                      v-model="fieldkey_key"
                      class="form-control"
                      placeholder="key"
                    />
									</div>

									<div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
										<label>Value</label>
										<input
                      data-w-input="ats-basic-fieldkey-value"
                      data-form-type="other"
                      type="text"
                      v-model="fieldkey_value"
                      class="form-control"
                      placeholder="value"
                    />
									</div>

									<div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
										<button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateFieldKeysByKeyValue">Add/Update</button>
										<button class="btn btn-danger" @click="removeFieldKeysByKeyValue">Remove</button>
									</div>
								</div>

								<small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>

								<small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

								<div class="relative flex flex-col border border-gray-200mt-3 mb-0">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<json-viewer :json="JSON.stringify(ats.field_keys)"/>
									</div>
								</div>
							</template>

							<!-- Builder Tab -->
							<template v-slot:builder>
								<JsonEditor :objData="ats.field_keys || {}" v-model="ats.field_keys"></JsonEditor>
							</template>

							<!-- Raw Tab -->
							<template v-slot:raw>
								<div class="card">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<textarea
                      data-w-input="ats-raw-fieldkeys"
                      rows="6" class="form-control"
                      @blur="ats.field_keys = $event.target.value"
                      :value="JSON.stringify(ats.field_keys)"
                    ></textarea>
									</div>
								</div>
							</template>
						</nav-tabs>
					</section>
					<hr style="margin: 2rem 0"/>

					<!-- Resources Section -->
					<section class="json-info">
						<h5>
							<span v-html="label('resources', 'Resources')"></span>
						</h5>
						<nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
							<!-- Basic Tab -->
							<template v-slot:basic>
								<div class="line-slipt">
									<div class="form-group" style="margin-bottom: 0.25rem">
										<label>Resource</label>
										<input
                      data-w-input="ats-basic-resources-key"
                      data-form-type="other"
                      type="text"
                      v-model="resources_key"
                      class="form-control"
                      placeholder="Resource"
                    />
									</div>

									<div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
										<label>Resource URL</label>
										<input data-w-input="ats-basic-resources-key" data-form-type="other" type="text" v-model="resources_value" class="form-control" placeholder="Resource URL"/>
									</div>
									<div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
										<button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateResourcesByKeyValue">Add/Update</button>
										<button class="btn btn-danger" @click="removeResourcesByKeyValue">Remove</button>
									</div>
								</div>

								<small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>
								<small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

								<div class="relative flex flex-col border border-gray-200mt-3 mb-0">
									<div class="header-row border-b border-gray-200">Data</div>

									<div class="card-body">
										<json-viewer :json="JSON.stringify(ats.resources)"/>
									</div>
								</div>
							</template>

							<!-- Builder Tab -->
							<template v-slot:builder>
								<JsonEditor :objData="ats.resources || {}" v-model="ats.resources"></JsonEditor>
							</template>

							<!-- Raw Tab -->
							<template v-slot:raw>
								<div class="card">
									<div class="header-row border-b border-gray-200">Data</div>
									<div class="card-body">
										<textarea
                      data-w-input="ats-raw-resources"
											rows="6"
											class="form-control"
											:value="JSON.stringify(ats.resources)"
											@blur="ats.resources = $event.target.value"
										></textarea>
									</div>
								</div>
							</template>
						</nav-tabs>
					</section>
					<hr style="margin: 2rem 0"/>

					<!-- Information Section -->
					<section class="json-info">
						<h5>
							<span v-html="label('information', 'Information')"></span>
						</h5>

						<nav-tabs :nav-items="['Basic', 'Builder', 'Raw']">
							<!-- Basic Tab -->
							<template v-slot:basic>
								<div class="line-slipt">
									<div class="form-group" style="margin-bottom: 0.25rem">
										<label>Title</label>
										<input
                      data-w-input="ats-basic-information-key"
                      data-form-type="other"
                      type="text"
                      v-model="information_key"
                      class="form-control"
                      placeholder="Title"
                    />
									</div>

									<div class="form-group" style="margin-bottom: 0.25rem; flex-grow: 2;">
										<label>Details</label>
										<input
                      data-w-input="ats-basic-information-value"
                      data-form-type="other"
                      type="text"
                      v-model="information_value"
                      class="form-control"
                      placeholder="Details"
                    />
									</div>

									<div style="display: flex; align-items: flex-end; margin-bottom: 0.25rem;">
										<button style="margin-right: 0.5rem;" class="btn btn-dark" @click="updateInformationByKeyValue">Add/Update</button>
										<button class="btn btn-danger" @click="removeInformationByKeyValue">Remove</button>
									</div>
								</div>

								<small style="display: block">To remove an item, input the key you wish to remove then click the remove button.</small>

								<small style="display: block">Adding a key that already exists will overwrite the current key/value.</small>

								<div class="relative flex flex-col border border-gray-200mt-3 mb-0">
									<div class="header-row border-b border-gray-200">Data</div>

									<div class="card-body">
										<json-viewer :json="JSON.stringify(ats.information)"/>
									</div>
								</div>
							</template>

							<!-- Builder Tab -->
							<template v-slot:builder>
								<JsonEditor :objData="ats.information || {}" v-model="ats.information"></JsonEditor>
							</template>

							<!-- Raw Tab -->
							<template v-slot:raw>
								<div class="card">
									<div class="header-row border-b border-gray-200">Data</div>

									<div class="card-body">
										<textarea
                      data-w-input="ats-raw-information"
                      rows="6"
                      class="form-control"
                      @blur="ats.information = $event.target.value"
                      :value="JSON.stringify(ats.information)"
                    ></textarea>
									</div>
								</div>
							</template>
						</nav-tabs>
					</section>
				</section>

				<hr style="margin: 2rem 0"/>

				<!-- Screenshot Section -->
				<ats-screenshots :ats-id="ats.id"></ats-screenshots>
			</div>

			<!-- Card Footer -->
			<div class="card-footer fixed bottom-0 left-0 right-0 z-30" style="background-color: rgba(250, 250, 250, .9)">
				<div class="container" style="text-align: right">
					<a :href="cancelUrl" :class="`btn btn-secondary ${saving ? 'pointer-events-none opacity-50' : ''}`">Cancel</a>

					<button
            data-w-submit
						class="btn btn-primary"
						:disabled="loading || saving || ats.name === '' ? 'disabled' : false"
						@click="$store.dispatch('ats/save')"
					>
						<i v-if="saving" class="fa fa-spinner fa-spin"></i>
						<i v-else class="fa fa-save"></i>
						Save
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import slugify from 'slugify';
import axios from 'axios';
import atsScreenshots from '../ats/AtsScreenshots';

export default {
	components: {
		atsScreenshots
	},
	props: {
		view: {type: String},
		submissionUrl: {type: String, required: true},
		cancelUrl: {type: String, required: true},
		ats: {
			type: Object, default() {
				return {
					name: '',
					slug: '',
					archived: false,
					allow_lead_modifications: false,
					export_details_ats: false,
					field_keys: {},
					rules: {},
					extra_rules: {},
					resources: {},
					information: {},
					screenshots: {},
				}
			}
		},
	},
	data() {
		return {
			rules_key: '',
			rules_value: '',
			extra_rules_key: '',
			extra_rules_value: '',
			fieldkey_key: '',
			fieldkey_value: '',
			resources_key: '',
			resources_value: '',
			information_key: '',
			information_value: '',
			loading: '',
			saving: false,
			screenshot_data: null,
		}
	},
	created() {
		this.$store.commit('ats/SET_URLS', {
			submissionUrl: this.submissionUrl,
			cancelUrl: this.cancelUrl,
		});

		this.$store.commit('ats/UPDATE_CURRENT', this.ats);
	},
	computed: {
		name() {
			return this.$store.state.ats.current.name;
		},
	},
	methods: {
		label(column_key, label) {
			return `<label class="" for="${column_key}">${label}</label>`;
		},
		updateRulesByKeyValue() {
			if (this.rules_key === '') return;

			let value = this.rules_value;

			try {
				if (typeof value === 'string') value = JSON.parse(value);

				this.ats.rules[this.rules_key] = value;
			} catch (e) {
				this.ats.rules[this.rules_key] = value;
			}

			Object.keys(this.ats.rules).forEach(key => {
				this.$store.commit('ats/UPDATE_CURRENT_RULES_FOR_KEY', {
					key: key,
					value: this.ats.rules[key]
				})
			});

			this.rules_key = '';
			this.rules_value = '';
		},
		updateExtraRulesByKeyValue() {
			if (this.extra_rules_key === '') return;

			let value = this.extra_rules_value;

			try {
				if (typeof value === 'string') value = JSON.parse(value);

				this.ats.extra_rules[this.extra_rules_key] = value;
			} catch (e) {
				this.ats.extra_rules[this.extra_rules_key] = value;
			}

			Object.keys(this.ats.extra_rules).forEach(key => {
				this.$store.commit('ats/UPDATE_CURRENT_extra_rules_FOR_KEY', {
					key: key,
					value: this.ats.extra_rules[key]
				})
			});

			this.extra_rules_key = '';
			this.extra_rules_value = '';
		},
		removeRulesByKeyValue() {
			if (this.ats.rules.hasOwnProperty(this.rules_key)) {
				this.$store.commit('ats/REMOVE_PROP_FROM_RULES', this.rules_key);
				this.rules_key = '';
				this.rules_value = '';
			}
		},
		removeExtraRulesByKeyValue() {
			if (this.ats.extra_rules.hasOwnProperty(this.extra_rules_key)) {
				this.$store.commit('ats/REMOVE_PROP_FROM_EXTRA_RULES', this.extra_rules_key);
				this.extra_rules_key = '';
				this.extra_rules_value = '';
			}
		},
		updateFieldKeysByKeyValue() {
			if (this.fieldkey_key === '') return;

			let value = this.fieldkey_value;

			try {
				if (typeof value === 'string') value = JSON.parse(value);

				this.ats.field_keys[this.fieldkey_key] = value;
			} catch (e) {
				this.ats.field_keys[this.fieldkey_key] = value;
			}

			Object.keys(this.ats.field_keys).forEach(key => {
				this.$store.commit('ats/UPDATE_CURRENT_FIELD_KEYS_FOR_KEY', {
					key: key,
					value: this.ats.field_keys[key]
				})
			});

			this.fieldkey_key = '';
			this.fieldkey_value = '';
		},
		removeFieldKeysByKeyValue() {
			if (this.ats.field_keys.hasOwnProperty(this.fieldkey_key)) {
				this.$store.commit('ats/REMOVE_PROP_FROM_FIELD_KEYS', this.fieldkey_key);
				this.fieldkey_key = '';
				this.fieldkey_value = '';
			}
		},
		updateResourcesByKeyValue() {
			if (this.resources_key === '') return;

			let value = this.resources_value;

			try {
				if (typeof value === 'string') value = JSON.parse(value);

				this.ats.resources[this.resources_key] = value;
			} catch (e) {
				this.ats.resources[this.resources_key] = value;
			}

			Object.keys(this.ats.resources).forEach((key) => {
				this.$store.commit('ats/UPDATE_CURRENT_RESOURCES_FOR_KEY', {
					key: key,
					value: this.ats.resources[key]
				})
			});

			this.resources_key = '';
			this.resources_value = '';
		},
		removeResourcesByKeyValue() {
			if (this.ats.resources.hasOwnProperty(this.resources_key)) {
				this.$store.commit('ats/REMOVE_PROP_FROM_RESOURCES', this.resources_key);
				this.resources_key = '';
				this.resources_value = '';
			}
		},
		updateInformationByKeyValue() {
			if (this.information_key === '') return;

			let value = this.information_value;

			try {
				if (typeof value === 'string') value = JSON.parse(value);

				this.ats.information[this.information_key] = value;
			} catch (e) {
				this.ats.information[this.information_key] = value;
			}

			Object.keys(this.ats.information).forEach(key => {
				this.$store.commit('ats/UPDATE_CURRENT_INFORMATION_FOR_KEY', {
					key: key,
					value: this.ats.information[key]
				})
			});

			this.information_key = '';
			this.information_value = '';
		},
		removeInformationByKeyValue() {
			if (this.ats.information.hasOwnProperty(this.information_key)) {
				this.$store.commit('ats/REMOVE_PROP_FROM_INFORMATION', this.information_key);
				this.information_key = '';
				this.information_value = '';
			}
		},
		update(key, value) {
			let ats = this.ats;

			ats[key] = value;

			//create slug if its for the name
			if (key === 'name' && this.view === 'create') {
				ats['slug'] = slugify(value).toLowerCase();
			}

			this.$store.commit('ats/UPDATE_CURRENT', ats);
		},
		uploadScreenshot() {
			this.saving = true;

			axios
				.post(`/support/ats/screenshots/upload`, this.screenshot_data, {
					headers: {'Content-Type': 'multipart/form-data'}
				})
				.then(response => {
					this.ats.screenshots[this.screenshot_data.get('type')] = response.data;

					this.screenshot_data = null;

					//reset file input
					jQuery('form#upload-screenshot input, form#upload-screenshot textarea').val(null);

					setTimeout(() => this.saving = false, 1000);
				})
				.catch(error => console.error(error));
		},
		removeScreenshot(type, screenshot) {
			this.saving = true;

			axios
				.delete(`/support/ats/screenshots/remove?ats-id=${this.ats.id}&type=${type}&screenshot=${screenshot}`)
				.then(response => {
					this.ats.screenshots[type] = response.data;

					setTimeout(() => this.saving = false, 250);
				})
				.catch(error => console.error(error));
		},
		screenshotChange() {
			this.screenshot_data = new FormData(document.querySelector('form#upload-screenshot'));
		},
		disableUpload() {
			return this.loading
				|| this.saving
				|| !this.screenshot_data
				|| !this.screenshot_data.get('title')
				|| !this.screenshot_data.get('screenshot').name;
		},
	}
}
</script>

<style lang="scss" scoped>
	[type=checkbox] {
		display: inline-block;
		width: 30px;
		margin: -5px 1rem 0 0;
		vertical-align: middle;
	}
</style>

<style lang="scss">
	label.error {
		color: #dc3545;
	}

	label .vendor-specific-label {
		display: block;

		.required {
			color: #dc3545;
			font-size: 1.6em;

			&:after {
				content: "*";
			}
		}
	}
</style>
